import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'circle-button',
  templateUrl: 'circle-button.component.html',
  styleUrls: ['circle-button.component.scss']
})
export class CircleButtonComponent {
  @Input() color: string = '';

  @HostBinding('class.circle-btn') circleBtn: boolean = true;

  @HostBinding('class.btn-responsive')
  @Input() responsive: boolean = false;

  @Output() onClick = new EventEmitter<any>();

  onCircleBtnClick() {
    this.onClick.emit(this);
  }
}
